module.exports = __webpack_public_path__ + "img/javascript.55bbd568.svg";